<template>
  <section id="values">
    <b-container text-center>
      <b-row>
        <b-col>
          <h1>Values</h1>
          <hr>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <i class="fas fa-bolt" aria-hidden="true"></i>
          <h3>Spark</h3>
          <p>Inspired by the sumo concept of tachi.ai, we empower bold entrepreneurs to find their footing and growth trajectory from the outset.</p>
        </b-col>
        <b-col md="4">
          <i class="fas fa-users" aria-hidden="true"></i>
          <h3>Partnership</h3>
          <p>
            We strive to be a partner beyond just our invested capital. We role up our sleeves and engage, even during
            the tough times.
          </p>
        </b-col>
        <b-col md="4">
          <i class="fas fa-globe" aria-hidden="true"></i>
          <h3>Japan</h3>
          <p>We help the startups we finance to scale into Japan's compelling enterprise market, particularly on the underserved Europe-Japan axis.</p>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
#values {
  padding: 5rem 0;
  display: flex;
  text-align: center;
}

#values .fas {
  margin: 5% 0;
  font-size: 4rem;
  padding: 10% 0% 0% 0%;
  color: #e74c3c;
}

#values hr {
  width: 20rem;
  height: 0.05rem;
  margin: 2rem auto 2rem;
}
</style>